import { CircularProgress } from '@mui/joy'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import BotTestConclusionImage from '@/assets/bot-test-conclusion-image.webp'
import { Column, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'
import { useAuth } from '@/contexts/AuthContext.tsx'
import { getFluencyTestResult } from '@/services/getFluencyTestResult.ts'
import { ROUTES } from '@/types/routes.ts'

export default function Processing() {
  const { code, configurations } = useAuth()

  const navigate = useNavigate()

  useEffect(() => {
    const interval = setInterval(async () => {
      const result = await getFluencyTestResult(code)
      if (result.status === 'FINISHED') {
        if (configurations.redirectUrl) {
          window.location.href = configurations.redirectUrl
        } else {
          navigate(ROUTES.RESULTS.concat(`?code=${code}`))
        }
      }
    }, 3000)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [navigate, code, configurations.redirectUrl])

  return (
    <AvatarCard
      variant="image"
      botAvatar={BotTestConclusionImage}
      animate={false}
    >
      <Column className="items-center">
        <Text.Translated
          size="3xl"
          className="!text-electric-indigo-900"
          fontWeight="bold"
          translationKey="test_completed_processing_result_states"
        />
        <Column className="h-2" />
        <Text.Translated
          size="md"
          color="600"
          translationKey="test_completed_processing_result_description"
        />
        <Column className="h-10" />
        <CircularProgress size="lg" />
      </Column>
    </AvatarCard>
  )
}
